import React from 'react';
import {CaptchaError} from '~/entities/captcha/api/useCaptcha';
import {RsnButton, RsnDialog} from '~/library/ui-kit';

export function CaptchaErrorDialog({error}: {error: CaptchaError}) {
    const {title, description, severity} = CaptchaErrorDialog.getTexts(error);
    return (
        <RsnDialog.Window>
            <RsnDialog.CenteredHeader icon={{element: <RsnDialog.StatusIcon status={severity} />}}>
                {title}
            </RsnDialog.CenteredHeader>
            <RsnDialog.Body>{description}</RsnDialog.Body>
            <RsnDialog.Footer>
                <RsnButton.Alike as={RsnDialog.CloseTrigger} intent='secondary'>
                    {'I got it'}
                </RsnButton.Alike>
            </RsnDialog.Footer>
        </RsnDialog.Window>
    );
}
CaptchaErrorDialog.getTexts = (
    error: CaptchaError
): {title: string; description: string; severity: 'alert' | 'attention'} => {
    switch (error._tag) {
        case 'CaptchaIsAborted':
        case 'CaptchaNotSolved':
        case 'TurnstileError':
            return {
                title: 'Something went wrong',
                description: "Don't worry, we'll fix it. Please try again later.",
                severity: 'alert',
            };
        case 'CaptchaRateLimit': {
            return {
                title: 'You need to wait a bit',
                description: 'Please try again later.',
                severity: 'attention',
            };
        }
        case 'UnsupportedShellVersion':
            return {
                title: 'Please update the app',
                description: 'Your app version is outdated. Please update the app in your app store to continue.',
                severity: 'alert',
            };
    }
};
